import React from 'react';
import { Tooltip, TooltipProps } from '@heroui/react';
import { ResponsiveTooltip } from './ui';

// Глобальные настройки для всех тултипов
const DEFAULT_TOOLTIP_CONFIG = {
  closeDelay: 200, // Задержка перед закрытием (мс)
  delay: 0, // Задержка перед открытием (мс)
  offset: 7, // Отступ от элемента
};

interface CustomTooltipProps extends Omit<TooltipProps, 'closeDelay' | 'delay' | 'offset'> {
  closeDelay?: number;
  delay?: number;
  offset?: number;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  closeDelay = DEFAULT_TOOLTIP_CONFIG.closeDelay,
  delay = DEFAULT_TOOLTIP_CONFIG.delay,
  offset = DEFAULT_TOOLTIP_CONFIG.offset,
  ...props
}) => {
  return <ResponsiveTooltip closeDelay={closeDelay} delay={delay} offset={offset} {...props} />;
};

export default CustomTooltip;
